"use client";

import type { Location } from "@/types/filters";
import type { MapItem } from "@/types/search";
import { storeMultipleLocationDetails } from "@/utils/location-details-store";
import { useEffect } from "react";

interface SSRLocationEnrichmentProps {
	mapData: MapItem[];
}

/**
 * Client-side component that enriches localStorage with location coordinates
 * from SSR data when the component mounts
 */
export function SSRLocationEnrichment({ mapData }: SSRLocationEnrichmentProps) {
	useEffect(() => {
		if (!mapData || mapData.length === 0) {
			return;
		}

		// Extract location details from map data
		const locationDetails: Location[] = mapData
			.filter(item => item.center && item.localityName)
			.map(item => ({
				id: Array.isArray(item._id) ? item._id.join("-") : item._id?.toString() || "",
				name: item.localityName,
				type: "landmark" as const,
				coordinates: {
					latitude: item.center!.lat,
					longitude: item.center!.lng,
				},
			}));

		if (locationDetails.length > 0) {
			// Store all location details in localStorage
			storeMultipleLocationDetails(locationDetails);
		}
	}, [mapData]);

	// This component doesn't render anything
	return null;
}
